<template>
    <div class="py-4 container-fluid">
      <div class="row">
        <!-- top buttons -->
        <div class="col-sm-12">
            <div class="card mb-4">
              <span class="fs-3">{{ this.store_name }}</span>
                <span class="top-actions"> 
                    <!--  -->
                    <!-- <h2 class="merge">{{ this.store_name }}   . </h2> -->
                    <button type="button" ref="makeRequestButton" class="mycustom-success-button" data-identifymodel="requesttype" data-bs-toggle="modal"  data-backdrop="static" data-keyboard="false" data-bs-target="#makeRequestModal">
                        <i class="bi bi-plus-square-dotted"></i> Make Request
                    </button>

                    <button type="button" class="mycustom-success-button" data-identifymodel="requesttype" data-bs-toggle="modal"  data-backdrop="static" data-keyboard="false"  data-bs-target="#dispatchModal">
                        <i class="bi bi-plus-square-dotted"></i> Dispatch
                    </button>
                    <button @click="process_issue">fgh</button>

                </span>
                
            </div>
        </div>
        <!-- end top buttons -->

        <div class="col-sm-12">
         <!-- table start -->
         <div class="card mb-4">
    
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <nav>
                <!-- <Search :PlaceHolder="placeHolderText" @search="handleSearch" /> -->
                <Search :placeholder=placeHolderText @onsearch="handleSearch" />
              </nav>
              <table class="table align-items-center mb-0 view-container">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      #s/n
                    </th>

                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Item Name
                    </th>

                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Origin Store
                    </th>


                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Destination Store
                    </th>

                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Quantity
                    </th>

                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Transfer Info
                    </th>

                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Order Status
                    </th>

                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Actions
                    </th>
                    
                   
                  </tr>
                </thead>

                <div  v-if="tableLoading">
                  <div class="loader" v-if="apiLoading">
                    <div class="spinner"></div>
                    <p>Loading...</p>
                  </div>
                </div>


                <tbody v-if="users.length">
                  <tr v-for="user in users" :key="user.id">
                    <td>
                      #{{ user.id  }}
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">   <itemname :ItemName="user.item_name"  :ItemBrand="user.brand_name"  :ItemStrength="user.item_strength"  />  </h6>
                          <p class="text-xs text-secondary mb-0">
                            {{ user.category_name  }} - {{ user.class_name }}
                          </p>
                        </div>
                      </div>
                    </td>

                    <td>
                     <!-- {{ user.batch_number }} -->
                     {{  user.origin_store_name }}
                    </td>
                    <td>
                      {{  user.destination_store_name }}
                    </td>
                    <td>
                      {{  user.quantity }}
                    </td>

                    <td>
                      {{  user.movement_type }}
                    </td>

                    <td>
                      {{  user.transaction_status }}
                    </td>

                   

                    <td>
                      <button v-if="user.initiating_store_id != this.$route.params.storeLocation && user.transaction_status == 'pending' && user.destination_store_id == this.$route.params.storeLocation"   v-on:click="process_transfer(user.id)"  class="mycustom-success-button">Accept</button> .
                      <button v-if="user.initiating_store_id != this.$route.params.storeLocation && user.transaction_status == 'pending' && user.destination_store_id == this.$route.params.storeLocation"  v-on:click="cancel_transfer(user.id)" class="mycustom-danger-button" >Reject</button>
                      <button  v-if="user.initiating_store_id == this.$route.params.storeLocation && user.transaction_status == 'pending'"  v-on:click="cancel_transfer(user.id)" class="mycustom-danger-button" >Cancel</button>
                      <button v-if="user.transaction_status == 'pending' &&  user.movement_type == 'Request'  && user.destination_store_id != this.$route.params.storeLocation"   v-on:click="process_issue(user.id)"  class="mycustom-success-button">Issue</button> .
                    </td>
                  
                  </tr>
                
                </tbody>
                <div v-else>
                  <p class="tocenter-container" v-if="!apiLoading">No Records found.</p>
                </div>
              </table>
               <!-- Pagination   @page-change="handlePageChange" :current-page="currentPage" :total-pages="totalPags" -->
                <!-- <pagination :all-data="allData" @content-change="handleContentChange" /> -->
                <div  v-if="apiLoading">Loading...</div>
                <pagination v-if="!apiLoading" :all-data="allData" @content-change="handleContentChange" @loader-set="loaderSet"/>

              <!--  -->
            </div>
          </div>
        </div>
         <!-- table end -->
         
        </div>
      </div>
      
    </div>

    <MakeRequestModal />
    <StockUploadModal />
    <DispatchModal />

  </template>
 

<script>
import { generalApiRequest } from "../../api/apiIndex";
import Pagination from '../components/pagination.vue';
import Search from '../components/search.vue';
import Itemname from './components/ItemName.vue';
import MakeRequestModal from './modals/makeRequestModal.vue';
import DispatchModal from './modals/dispatchModal.vue';
import StockUploadModal from './modals/stockUpload.vue';
//import axios from "axios";
 import { Modal } from 'bootstrap'

export default {
  name: "internalorders",
  data() {
    return {
      users: [],
      allData:{},
      apiLoading:true,
      tableLoading:true,
      placeHolderText:"Search Item...",
      selected_store:null,
      store_name:"",
      store_list:[]
    };
  },
  components: {
    Pagination,
    Search,
    Itemname,
    MakeRequestModal,
    StockUploadModal,
    DispatchModal
  },
  
  methods: {
    async handleSearch(searchTerm){
      //console.log("the serch rem is " +searchTerm);
      try {
        this.apiLoading = true;
          const url = 'inventory/search_movement_index/'+this.$route.params.storeLocation; 
          const body = { search_param: searchTerm};
// console.log(body);
          const rs = await generalApiRequest(url, 'GET', body, 1);
        //  console.log(rs);
          this.allData = rs.data;
          this.apiLoading = false;
          // console.log(this.allData);

      } catch (error) {
         console.error('Error fetching data:', error);
      }
   
    },

    handleMakeRequestClick() {
      const identifyModelValue = this.$refs.makeRequestButton.dataset.identifymodel;
      console.log("identifyModel value:", identifyModelValue);
    },
    
    handleContentChange(contents) {
      // console.log("procceds");
      // console.log("=======================");
      //  console.log(contents);
      //  console.log("=======================");
      this.users = contents;
    },

    loaderSet(value){
      if (value==true) {
        this.users= [];
      }
      this.tableLoading = value;
      //console.log(value);
      //this.apiLoading = value;
    },

  async cancel_transfer(code){
      try {
        const url = 'inventory/cancelStockTransfer'; 
            const body = {id: code};

            const action_cancel = await generalApiRequest(url, 'POST', body, 1);
            if (action_cancel) {
              for (let i = 0; i < this.users.length; i++) {
                  if (this.users[i].id === code) {
                    this.users[i].transaction_status = 'cancelled';
                  }
              };
            }
      } catch (error) {
        console.log(error);
      }
    },
  
  async process_issue(){
    // Access the modal element using $refs
    let myModal = new Modal(document.getElementById('dispatchModal'));
    myModal.show();

  },

  async process_transfer(code){
    try {
        const url = 'inventory/processStockTransfer'; 
            const body = {id: code};
            
            const action_cancel = await generalApiRequest(url, 'POST', body, 1);
            if (action_cancel) {
              for (let i = 0; i < this.users.length; i++) {
                  if (this.users[i].id === code) {
                    this.users[i].transaction_status = 'completed';
                  }
              };
            }
      } catch (error) {
        console.log(error);
      }
  },

    async get_stores_list(){
      //store_id
      try {
        const url = 'inventory/getCompanyItemStores_for_input'; 
        const body = {};
    
       // const data = await getMethodRequest(url, body, 1);
        const store_list = await generalApiRequest(url, 'GET', body, 1)
         //console.log(data);
        store_list.forEach(element => {
           // console.log(element.id+" - "+this.$route.params.storeLocation);
            if (element.id == this.$route.params.storeLocation) {
                this.store_name = element.store_name;
            }
            
        });

      } catch (error) {
         console.error('Error fetching data:', error);
      }

    },

    async callApi() {
      try {
        const storeLocation = this.$route.params.storeLocation;
        //const url = 'inventory/getAllCompanyItems'; //?page=1 item_stock/storeLocation
        const url = 'inventory/movement_index/'+storeLocation;
        const body = {};
    
       // const data = await getMethodRequest(url, body, 1);
        const data = await generalApiRequest(url, 'GET', body, 1)
         //console.log(data);
        this.allData = data.data;
        this.apiLoading = false;
      } catch (error) {
         console.error('Error fetching data:', error);
      }
    },
    
  },

  mounted() {
    this.callApi();
    this.get_stores_list();
    
  },
};
</script>

<style scoped>
.merge{
   padding-right: "30px";
}
.view-container{
     max-width: 90vw; 
} 
.width-limit{
    width: '5px';
}
</style>


  